import { render, staticRenderFns } from "./SupplierStatistics.vue?vue&type=template&id=02c7d1d5&scoped=true"
import script from "./SupplierStatistics.vue?vue&type=script&lang=js"
export * from "./SupplierStatistics.vue?vue&type=script&lang=js"
import style0 from "./SupplierStatistics.vue?vue&type=style&index=0&id=02c7d1d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c7d1d5",
  null
  
)

export default component.exports